<template>
  <a
    class="privacy-link"
    href="/datenschutz.html"
    target="_blank"
    rel="noopener noreferrer"
    @click.stop
  >
    {{ linkText }}
  </a>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  props: {
    linkText: {
      type: String,
      default: 'Datenschutzerklärung'
    }
  }
}
</script>

<style scoped>
.privacy-link {
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
  font-weight: 500;
}

.privacy-link:hover {
  opacity: 0.7;
}
</style>
